interface StatusGifProps {
  src: string;
  alt: string;
}

const StatusGif = ({ src, alt }: StatusGifProps) => {
  return (
    <div className={"gg-mb-4 gg-flex gg-items-center gg-justify-center"}>
      <span
        className={
          "gg-bg-dark-blue-30 gg-inline-block gg-aspect-square gg-overflow-hidden gg-rounded-full " +
          "gg-h-[200px] sm:gg-h-[300px]"
        }
      >
        <div className={"gg-block gg-h-full gg-w-full gg-overflow-hidden"}>
          <img
            src={src}
            alt={alt}
            className={
              "gg-block gg-h-full gg-w-full gg-object-cover gg-object-center"
            }
          />
        </div>
      </span>
    </div>
  );
};
export default StatusGif;
